import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MustWatchEpisodesService {

    private API_URL= environment.API_URL;
    
    constructor(
        private http : HttpClient,
        private sanitizer: DomSanitizer
    ) {}

    // getAfroTechLearnVideos_old(maxResults = 4) {
    //     const playlistUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=${maxResults}&playlistId=${this.YOUTUBE_LEARN_PLAYLIST_ID}&key=${this.YOUTUBE_API_KEY}`;
    
    //     return this.http.get<any>(playlistUrl).pipe(
    //       mergeMap(response => {
    //         const items = response.items;
    //         const videoIds = items.map((item: any) => item.snippet.resourceId.videoId).join(',');
    
    //         const videoDetailsUrl = `https://www.googleapis.com/youtube/v3/videos?part=contentDetails&id=${videoIds}&key=${this.YOUTUBE_API_KEY}`;
    
    //         return this.http.get<any>(videoDetailsUrl).pipe(
    //           map(videoResponse => {
    //             const durationsMap: Record<string, string> = {};
    //             videoResponse.items.forEach((v: any) => {
    //               durationsMap[v.id] = this.convertISO8601ToMinutes(v.contentDetails.duration);
    //             });
    
    //             return items.map((item: any) => {
    //               const videoId = item.snippet.resourceId.videoId;
    
    //               return {
    //                 title: item.snippet.title,
    //                 date: item.snippet.publishedAt,
    //                 badge: 'LEARN',
    //                 videoId,
    //                 thumbnail: item.snippet.thumbnails?.medium?.url || '',
    //                 safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`),
    //                 duration: durationsMap[videoId] || '~3 min'
    //               };
    //             });
    //           })
    //         );
    //       })
    //     );
    // }

    getAfroTechLearnVideosFromYoutube(maxResults = 4): Observable<any[]> {
      const url = `${this.API_URL}/youtube/learn-videos?maxResults=${maxResults}`;
      
      return this.http.get<any[]>(url, { headers: {'Authorization': `Bearer ${environment.API_TOKEN}`}});
    }

    getAfroTechLearnVideos(limit: number = 4) {
        const url = `${this.API_URL}/afro-tech-learns?populate=*&sort=publishedAt:desc&pagination[limit]=${limit}`;
      
        return this.http.get(url, {
          headers: {
            Authorization: `Bearer ${environment.API_TOKEN}`,
          },
        });
    }      
}